// extracted by mini-css-extract-plugin
export var contentCard = "bq_dz";
export var gridBase = "bq_dw";
export var gridElement = "bq_dB";
export var gridTumbleIn = "bq_dC";
export var heightAuto = "bq_dy";
export var heightFull = "bq_dx";